import React, { useState } from "react";
import MapTb from "./MapTb";

const AnalisisTb = () => {
  const [data, setdata] = useState([
    {
      terduga: 67,
      kasus: 11,
      screening: 54,
      tahun: "2022",
      display: "TAMANMARTANI",
      lang: "-7.746752",
      lat: "110.481071",
    },
    {
      terduga: 41,
      kasus: 10,
      screening: 292,
      tahun: "2023",
      display: "TAMANMARTANI",
      lang: "-7.746752",
      lat: "110.481071",
    },
  ]);
  const [tahun, settahun] = useState("2023");
  return (
    <div>
      <div className="card">
        <div className="card-header">
          <div className="row">
            Peta Analisis TB
              <button
                type="button"
                className="btn btn-sm btn-neutral mr-0 ml-3"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {tahun}
              </button>
              <div
                className="dropdown-menu dropdown-menu-lift"
                x-placement="bottom-end"
                style={{
                  position: "absolute",
                  willChange: "transform",
                  top: 0,
                  left: 0,
                  transform: "translate3d(45px, 28px, 0px)",
                }}
              >
                <span
                  className="dropdown-item"
                  onClick={() => settahun("2022")}
                >
                  {2022}
                </span>
                <span
                  className="dropdown-item"
                  onClick={() => settahun("2023")}
                >
                  {2023}
                </span>
              </div>
          </div>
        </div>
        <div className="card-body">
          {data.find((e) => e.tahun == tahun) ? (
            <MapTb data={data.filter((e) => e.tahun == tahun)} tahun={tahun} />
          ) : (
            <div>Menyiapkan Data</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnalisisTb;
